import React from 'react'
import {BaseButton, Flex, Stack, Text} from '../../../../vanilla'
import {ExclamationCircleIcon} from '../../../icons'
import {useBasketStore} from '../../../../store/hooks/useStore'
import {Link} from '../../../link'
import {drawerBookingSlotText} from './styles.css'
import useDeliveryBooking from '../../../../hooks/use-delivery-booking'
import {MobileNavigationLoggedLinksProps} from '../../../header/mobile-navigation-drawer/mobile-navigation-logged-links'
import { DeliveryTimeAndDate } from '../../../book-delivery/delivery-time-and-date'

export const ReservationExpiredSlot = ({ onClose }: MobileNavigationLoggedLinksProps) => {
  const {currentDeliverySlotId, currentDeliveryDay} = useBasketStore()
  const {day, month, isAvailable} = currentDeliveryDay || {}
  
  const {reserveSlot} = useDeliveryBooking()

  return (
    <Stack spacing="4px" flexShrink="0" marginY="8px">
      <Flex gap="2px" align="center">
        <ExclamationCircleIcon color="accent0" boxSize="12px" marginRight="4px" />
        <Text color="accent0" className={drawerBookingSlotText}>
          Your delivery reservation has expired!
        </Text>
      </Flex>

      <Text color="gray800" className={drawerBookingSlotText} lineHeight="short">
        Your delivery time:
      </Text>
      <DeliveryTimeAndDate textProps={{color: "gray800", className: drawerBookingSlotText, lineHeight: "short"}} />
      <Text color="gray800" className={drawerBookingSlotText} lineHeight="short">
        {day} {month}
      </Text>
      <BaseButton
        variant="primary"
        data-test-selector="book-delivery-time-button"
        size="sm"
        alignSelf="stretch"
        {...(isAvailable
          ? {onClick: () => reserveSlot(currentDeliverySlotId)}
          : {as: Link, to: '/book-delivery'})}
        marginTop="4px"
      >
        <Text
          variant="unstyled"
          fontSize="inherit"
          lineHeight="inherit"
          fontWeight="inherit"
          align="center"
          onClick={onClose}
        >
          {isAvailable ? 'Rebook' : 'Book a New Delivery Time'}
        </Text>
      </BaseButton>
    </Stack>
  )
}
